import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IColumnProps } from '../components/grid/column/column';

export class ColumnModel extends ContentItem {
  get containItems(): IKontentItem[] {
    return get(this._config, 'elements.contain_items.value', []);
  }

  get aligmentInColumn(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_column.value[0].codename',
      'default'
    );
  }

  get aligmentInRow(): string {
    return get(
      this._config,
      'elements.aligment_items__aligment_in_row.value[0].codename',
      'default'
    );
  }

  get border(): boolean {
    return get(this._config, 'elements.border.value[0].codename') === 'true';
  }

  get asset(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.asset.value[0]', '');
  }

  get fullSizeAsset(): boolean {
    return (
      get(this._config, 'elements.full_size_asset.value[0].codename') === 'true'
    );
  }

  get assetHeight(): number {
    return get(this._config, 'elements.asset_height.value', null);
  }

  get additionalMarginInColumn(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_column.value[0].codename',
      ''
    );
  }
  get additionalMarginInRow(): string {
    return get(
      this._config,
      'elements.additional_margin__additional_margin_in_row.value[0].codename',
      ''
    );
  }

  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      ''
    );
  }

  public static create(data: IColumn): IColumnProps {
    const {
      containItems,
      aligmentInColumn,
      aligmentInRow,
      border,
      fullSizeAsset,
      additionalMarginInColumn,
      additionalMarginInRow,
      asset,
      assetHeight,
      backgroundColor
    } = new ColumnModel(data);
    return {
      containItems,
      aligmentInColumn,
      aligmentInRow,
      border,
      asset,
      fullSizeAsset,
      additionalMarginInColumn,
      additionalMarginInRow,
      assetHeight,
      backgroundColor
    };
  }
}
